import { NextFunctionComponent } from "next";
import React from "react";
import { SimpleFooter } from "../src/components/SimpleFooter";
import { Topbar } from "../src/components/Header";
import { LandingTitleContextProvider } from "../src/modules/common/context/landingTitle";
import { Head } from "../src/modules/products/components/Head";
import { Header } from "../src/modules/products/components/Header";
import { Results } from "../src/modules/products/components/Results";
import { FiltersContextProvider } from "../src/modules/products/context/filters";
import { LandingContextProvider } from "../src/modules/products/context/landing";
import { SelectedFiltersProvider } from "../src/modules/products/context/selectedFilters";
import { isTravel } from "../src/modules/products/helpers/isTravel";
import { PromotionQuery } from "../src/queries/landing/PromotionQuery";
import { useAppContext } from "../src/lib/appContext";
import { getConfig } from "../config/app";
import { TopDestinationsProps } from "../src/modules/products/components/Content/TravelBrazil/TopDestinations";

const ProductsLanding: NextFunctionComponent<Pick<TopDestinationsProps, "destinations">> = ({
  destinations
}) => {
  const {
    countryCode,
    businessUnitConfig: { businessUnit }
  } = useAppContext();

  return (
    <PromotionQuery variables={{ countryCode, businessUnit }}>
      <LandingContextProvider>
        <FiltersContextProvider>
          <SelectedFiltersProvider>
            <LandingTitleContextProvider landingName="results">
              <Topbar showMenu={false} />
              <Head />
              <Header />
            </LandingTitleContextProvider>
            <Results destinations={destinations} />
            <SimpleFooter />
          </SelectedFiltersProvider>
        </FiltersContextProvider>
      </LandingContextProvider>
    </PromotionQuery>
  );
};

ProductsLanding.getInitialProps = async ctx => {
  const { businessUnitConfig, countryCode } = ctx.req || window.__NEXT_DATA__.props;
  if (isTravel(businessUnitConfig.businessCode)) {
    const topDestinationsUrl = getConfig(`quoterBot.destinations.${countryCode}`);
    try {
      const destinations = await fetch(topDestinationsUrl).then(response => response.json());
      return { destinations };
    } catch {
      return {};
    }
  }
  return {};
};

export { ProductsLanding as default };
